import { BrowserRouter } from 'react-router-dom';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { AppRoutes } from './routes/AppRoutes';

const App = () => {
  return (
    <BrowserRouter basename={import.meta.env.APP_BASE_ROUTE}>
      <AppErrorBoundary>
        <AppRoutes />
      </AppErrorBoundary>
    </BrowserRouter>
  );
};

export default App;
